<div [ngClass]="containerClass">
    <img style="width: 100%" [src]="imageSrc" [alt]="altText" [style.height]="height">
</div>
<!-- @if(showSpacing){ -->
<!-- <br><br> -->
<!-- } -->


<!-- <div [ngClass]="containerClass">
    @if (ad()) {
    <a [href]="ad()?.url" target="_blank">
        <img [src]="ad()?.image?.path | imageUrl" [alt]="ad()?.name" style="width:100%" [style.height]="height">
    </a>
    } @else {
    <img [src]="fallbackImage" alt="Advertisement" style="width:100%" [style.height]="height">
    }
</div>

@if (showSpacing) {
<br><br>
} -->